export enum W4Params {
  TotalAllowances = "TOTALALLOWANCES",
  TwoJobs = "TWO_JOBS",
  Deductions = "DEDUCTIONS",
  OtherIncome = "OTHER_INCOME",
  DependentsAmt = "DEPENDENTS_AMT",
  W42020 = "2020_W4",
  FilingStatus = "FILINGSTATUS",
}

export enum FilingStatus2020 {
  Single = "S",
  Married = "M",
  Head_Of_Household = "H",
  Nonresident_Alien = "NRA",
}

export enum FilingStatusNon2020 {
  Single = "S",
  Married = "M",
  Married_With_Single_Rate = "MH",
  Nonresident_Alien = "NRA",
}